import { useState } from 'react'

import { EuiText } from '@elastic/eui'
import { EuiFlexItem } from '@elastic/eui'
import { EuiFlexGroup } from '@elastic/eui'
import { EuiButton } from '@elastic/eui'

interface ResearchDocumentProps {
  title: string
  description: string
  onDownload: () => Promise<void>
  isDownloadDisabled?: boolean
  downloadText?: string
}

export const ResearchDocumentSection = ({ title, description, onDownload, isDownloadDisabled, downloadText }: ResearchDocumentProps) => {
  const [isDownloading, setIsDownloading] = useState(false)

  const onClickDownload = async () => {
    setIsDownloading(true)
    try {
      await onDownload()
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <>
      <EuiText>
        <b>{title}</b>
      </EuiText>
      <EuiFlexGroup>
        <EuiFlexItem grow={5}>
          <EuiText>{description}</EuiText>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButton size='s' iconType='popout' fullWidth={false} onClick={onClickDownload} isLoading={isDownloading} disabled={isDownloadDisabled}>
            {downloadText ? downloadText : 'Download PDF'}
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem />
      </EuiFlexGroup>
    </>
  )
}
